import { render } from "./templates/sidebar-right.html?vue&type=template&id=e7322684"
import script from "./sidebarRight.vue?vue&type=script&lang=js"
export * from "./sidebarRight.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__